import RelatedArticles from './RelatedArticles';
export default RelatedArticles;